// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GridItemOverlay from './Izenda.GridItemOverlay';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

class GridItems extends Component {
  static propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    gridLines: PropTypes.object,
    gridItems: PropTypes.array,
    layoutStore: PropTypes.object,
    stickyScrollBottom: PropTypes.number
  };

  render() {
    const { className, style, gridLines, gridItems, layoutStore } = this.props;
    return (
      <div className={className} style={style}>
        {gridLines}
        {gridItems}
        <GridItemOverlay layoutStore={layoutStore} />
      </div>
    );
  }

  shouldComponentUpdate(nextProps: any) {
    return this.props.stickyScrollBottom === nextProps.stickyScrollBottom;
  }
}

class GridItemsContainer extends Component {
  static propTypes = {
    printingMode: PropTypes.bool,
    editable: PropTypes.bool,
    fullSize: PropTypes.bool,
    fullHeight: PropTypes.bool,
    scrollBoxStyle: PropTypes.object,
    viewClassName: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    gridLines: PropTypes.object,
    gridItems: PropTypes.array,
    layoutStore: PropTypes.object,
    stickyScrollBottom: PropTypes.number
  };

  static DisplayName = 'GridItemsContainer';

  constructor(props: Object) {
    super(props);
  }

  /**
   * Render grid items
   */
  renderGridItems() {
    const { className, style, gridLines, gridItems, layoutStore, stickyScrollBottom } = this.props;
    return (
      <GridItems
        className={className}
        style={style}
        gridLines={gridLines}
        gridItems={gridItems}
        layoutStore={layoutStore}
        stickyScrollBottom={stickyScrollBottom}
      />
    );
  }

  /**
   * Render grid items with scroll box
   */
  renderGridItemsWithScrollBox() {
    const {
      fullHeight,
      fullSize,
      scrollBoxStyle,
      viewClassName,
      stickyScrollBottom,
      alwaysShowHorizontalScroll,
      alwaysShowVerticalScroll
    } = this.props;
    return (
      <ScrollBox
        ref="scrollBox"
        stickyScrollBottom={stickyScrollBottom}
        alwaysShowHorizontalScroll={alwaysShowHorizontalScroll}
        alwaysShowVerticalScroll={alwaysShowVerticalScroll}
        fullHeight={fullHeight}
        fullSize={fullSize}
        isDisabled={fullSize}
        containerStyle={scrollBoxStyle}
        viewClassName={viewClassName}
      >
        {this.renderGridItems()}
      </ScrollBox>
    );
  }

  render() {
    const { printingMode, editable, layoutStore } = this.props;
    return (printingMode || !editable || layoutStore.readOnlyMode) ? this.renderGridItems() : this.renderGridItemsWithScrollBox();
  }
}

export default GridItemsContainer;



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridItemsContainer.js